// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-container[data-v-a1adfd1a]{position:relative;height:450px}", ""]);
// Exports
module.exports = exports;
